import { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);
const KEY = "laze_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch {}
  }, []);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const lineKey = (i) => `${i.product_id}__${i.size}__${i.color || ""}`;

  const addItem = useCallback((item) => {
    setItems((prev) => {
      const k = lineKey(item);
      const found = prev.find((p) => lineKey(p) === k);
      if (found) {
        return prev.map((p) => (lineKey(p) === k ? { ...p, qty: Math.min(p.qty + item.qty, 20) } : p));
      }
      return [...prev, item];
    });
    setOpen(true);
  }, []);

  const updateQty = useCallback((key, qty) => {
    setItems((prev) => prev.map((p) => (lineKey(p) === key ? { ...p, qty } : p)));
  }, []);

  const removeItem = useCallback((key) => {
    setItems((prev) => prev.filter((p) => lineKey(p) !== key));
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, open, setOpen, addItem, updateQty, removeItem, clear, subtotal, count, lineKey }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
